import React from "react";

const StatCardSkeleton = () => {
  return (
    <div className="cursor-pointer">
      <div className="shadow-md rounded-lg p-4 animate-pulse bg-white">
        <div className="flex items-center justify-between">
          {/* Left text block */}
          <div className="flex flex-col gap-2">
            {/* Title */}
            <div className="h-3 w-24 bg-gray-200 rounded"></div>

            {/* Value */}
            <div className="h-6 w-16 bg-gray-300 rounded"></div>

            {/* Trend */}
            <div className="h-3 w-32 bg-gray-200 rounded mt-1"></div>
          </div>

          {/* Icon placeholder */}
          <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export default StatCardSkeleton;
